// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@flip/XDL/types";

export default {
    primary: {
        main: "#558019",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#AED639",
        contrast: "#FFFFFF",
    },
    tertiary: {
        main: "#679D1F",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#CCCCCC",
        disabled: "#CCCCCC",
        ui1: "#FFFFFF",
        ui2: "#EEEEEE",
        ui3: "#CCCCCC",
        ui4: "#999999",
        ui5: "#666666",
        ui6: "#333333",
        ui7: "#000000",
        ui8: "#464646",
        ui9: "#939698",
        ui10: "#BEBDC0",
        ui11: "#47516E",
        ui12: "#3F5F13",
        ui13: "#78B424",
        ui14: "#979797",
        ui15: "#F5FFF4",
        ui16: "#EBF5CD",
        ui17: "#41550f",
        white: "#FFFFFF",
    },
    text: {
        main: "#333333",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#558019",
    },
    success: {
        main: "#00A65A",
        contrast: "#FFFFFF",
        light: "#D9F2E7",
    },
    danger: {
        main: "#E4104E",
        contrast: "#FFFFFF",
        light: "#FBDBE5",
    },
    warning: {
        main: "#DAA91C",
        contrast: "#FFFFFF",
        light: "#FDF9DE",
    },
    info: {
        main: "#53ACDB",
        contrast: "#FFFFFF",
        light: "#DDEEF8",
    },
} as xBaseTheme["colors"];
